/*
  The header's speech bubble with a count in it: how many puzzles have unread replies to the player.

  Drawn in a 24-unit box, stroked in the header icons' black, with the count in Quicksand Bold. The
  count is placed by its baseline rather than centred on its em box, which leaves digits sitting low:
  they have no descenders, so the visible figure is the 0.71em above the baseline, and that is what's
  centred on the bubble's middle.
*/

export const COUNT_BUBBLE = {
  viewBox: 24,
  /** The bubble, with its tail at the lower left. */
  path: 'M6 3h12a4 4 0 0 1 4 4v7a4 4 0 0 1-4 4h-7l-4.5 3.5V18H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4z',
  strokeWidth: 2,
  /** Where the count goes across, and the middle of the bubble's body (y 3 to 18) down. */
  centerX: 12,
  centerY: 10.5,
} as const;

/** Two digits come down a size to fit. */
export const countBubbleFontSize = (count: number) => (count > 9 ? 9 : 11);

/** Quicksand Bold's digits stand this tall above the baseline, as a fraction of the font size. */
const DIGIT_HEIGHT = 0.71;

/** The baseline that centres the digits of a count at `fontSize` in the bubble. */
export const countBubbleBaseline = (fontSize: number) => COUNT_BUBBLE.centerY + (DIGIT_HEIGHT / 2) * fontSize;
